import { sectionMetrics } from "../../model/sectionMetrics";
import type { FindingCategory } from "../../model/Finding";
import { MetricRows } from "./MetricRows";
import { OtherFindings } from "./OtherFindings";
import type { SectionProps } from "./SectionProps";

// Секция без своего вида (прокачка): находки карточками, метрики — строками, если они есть
// в подробностях разбора.
export const PlainSection = ({ report, findings }: SectionProps) => {
  const category: FindingCategory | undefined = findings[0]?.category;
  const metrics = category === undefined ? [] : sectionMetrics(report.details, category);
  return (
    <>
      <OtherFindings
        findings={findings}
        shown={metrics.length > 0 ? ["metric"] : []}
        hasContent={metrics.length > 0}
      />
      <MetricRows metrics={metrics} />
    </>
  );
};
